import { useTranslation } from "react-i18next";
import * as React from "react";

import { GoalPage } from ".";
import { SecondaryButton } from "../Button";
import { GoalTargetList } from "../GoalTargetList";
import { SectionHeader } from "./SectionHeader";

export function Targets(props: GoalPage.State) {
  const { t } = useTranslation();
  const [addActive, setAddActive] = React.useState(false);

  return (
    <div>
      <SectionHeader
        title={t("Targets")}
        buttons={
          <SecondaryButton size="xxs" onClick={() => setAddActive(true)} testId="add-target">
            {t("Add")}
          </SecondaryButton>
        }
        showButtons={props.permissions.canEdit && !addActive}
      />

      {Boolean(!addActive && props.targets.length === 0) && (
        <div className="mt-1">
          <div className="text-content-dimmed text-sm">
            {props.permissions.canEdit
              ? t("Add targets to track quantitative progress with numbers.")
              : t("The champion hasn't yet set targets for this goal.")}
          </div>
        </div>
      )}

      <div className="mt-3">
        <GoalTargetList
          targets={props.targets}
          canReorder={props.permissions.canEdit}
          showEditButton={props.permissions.canEdit}
          showUpdateButton={props.permissions.canEdit}
          addActive={addActive}
          onAddActiveChange={(active) => setAddActive(active)}
          addTarget={props.addTarget}
          deleteTarget={props.deleteTarget}
          updateTarget={props.updateTarget}
          updateTargetValue={props.updateTargetValue}
          updateTargetIndex={props.updateTargetIndex}
        />
      </div>
    </div>
  );
}
